module.exports = __webpack_public_path__ + "img/preview-placeholder.c9397349.svg";